var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-container',{attrs:{"id":"app","fluid":""}},[_c('Page-Heading',{staticClass:"mb-1",attrs:{"msg":"Vault"}}),_c('Login')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }